export default "__VITE_ASSET__485a19e1__"